const ShortText = ({ text, maxCharacters }) => {
  return text.length > maxCharacters
    ? `${text.substr(0, maxCharacters - 1)}...`
    : text;
};

export default ShortText;
